
import { CategorieMessage } from '@/model/enum-types/categorie-message';
import { CodeDomaine } from '@/model/enum-types/code-domaine';
import { getMessagesStoreBuilder } from '../abstract/abtract-messages';

const builder = getMessagesStoreBuilder('visionMarcheArticleEngrais', CodeDomaine.ENGRAIS, CategorieMessage.VISION_MARCHE_ARTICLE);

export default builder.build();
